<template>
  <div :class="['manage-users-container', errorMessage ? 'slide-down' : 'slide-up']">
    <div :class="['error-message-bubble', errorMessage ? 'slide-down' : 'slide-up']">{{errorMessage}}</div>

    <h3>manage users</h3>
    <router-link to="/settings/manage-users/advertiser-user" class="new-user-button button" tag="button">
      new user
    </router-link>

    <modal
        v-if="showDeleteModal"
        buttonText="yes"
        showActionButton
        showClose
        wrapperClasses="image-preview-modal"
        @close="showDeleteModal = false"
        @proceed="deleteAdvertiserUser()">
      <div slot="header">
        <h3 class="sub-title">delete user</h3>
      </div>
      <div slot="body" class="image-preview-wrapper">
        <p>are you sure you want to delete this user?</p>
      </div>
    </modal>

    <loading-icon v-if="userLoading"></loading-icon>
    <sb-table
      :columns="columns"
      :rows="users"
      v-else
    >
      <template #cell="{ row, column }">
        <div v-if="column.key === 'name'" >
          <span v-if="row.user.name !== 'null'">{{row.user.name}}</span>
        </div>
        <div v-if="column.key === 'phone_number'" >
          {{formatPhone(row.user.phone_number)}}
        </div>
        <div v-if="column.key === 'email'" >
          {{row.user.email}}
        </div>
        <div v-if="column.key === 'edit'" class="edit-cell">
          <router-link :to="`/settings/manage-users/advertiser-user/${row.id}`" class="link">
            edit
          </router-link>
        </div>
        <div v-if="column.key === 'delete'" :class="['delete-cell', { 'delete' : row.user.is_current_user === true}]">
          <a @click="deleteModal(row.id)" class="delete-user">delete</a>
        </div>
      </template>
    </sb-table>
    <pagination
        v-if="!userLoading && totalPageCount && totalPageCount > 1"
        :currentPage="currentPage"
        :totalPageCount="totalPageCount"
        showArrows
        @changePage="changePage">
    </pagination>
  </div>
</template>

<script>
import { brandsAPI } from "../../services/api/brands"
import { advertiserUserAPI } from '../../services/api/advertiserUserAPI'
import Pagination from '../Shared/Pagination'
import LoadingIcon from '../Shared/LoadingIcon'
import Modal from '../Shared/Modal'

export default {
  name: 'ManageUsers',

  props: {
    currentAdvertiser: Object,
  },

  components: {
    LoadingIcon,
    Pagination,
    Modal
  },

  data() {
    return {
      columns:[
        { label:'name', key:'name' },
        { label:'mobile number', key:'phone_number' },
        { label:'email', key: 'email'},
        { label: '', key: 'edit'},
        { label: '', key: 'delete'}
      ],
      currentPage: 1,
      errorMessage: null,
      genericApiError: "error, please try again or contact support",
      id: null,
      showDeleteModal: false,
      totalPageCount: 1,
      users: [],
      userLoading: false
    }
  },

  created() {
    this.getAllAdvertiserUsers()
  },

  methods: {
    async getAllAdvertiserUsers() {
      this.userLoading = true
      this.errorMessage = null

      try {
        const data = await advertiserUserAPI.getAllAdvertiserUsers(this.currentAdvertiser.id, this.currentPage)
        this.users = data.users_advertisers
        this.totalPageCount = data.pagination.total_pages
      } catch (error) {
        this.errorMessage = this.genericApiError
      } finally { this.userLoading = false }
    },

    async deleteAdvertiserUser() {
      this.showDeleteModal = false
      this.userLoading = true
      this.errorMessage = null

      try {
        await advertiserUserAPI.deleteAdvertiserUsers(this.currentAdvertiser.id, this.id)
        this.getAllAdvertiserUsers()
      } catch (error) {
        this.errorMessage = this.genericApiError
      } finally { this.userLoading = false }
    },

    changePage(page) {
      this.errorMessage = null
      this.currentPage = page
      this.userLoading = true

      this.getAllAdvertiserUsers()
    },

    deleteModal(id) {
      this.id = id
      this.showDeleteModal = true
    },

    formatPhone(phone) {
      const phoneTest = new RegExp(/^((\+1)|1)? ?\(?(\d{3})\)?[ .-]?(\d{3})[ .-]?(\d{4})( ?(ext\.? ?|x)(\d*))?$/)

      phone = phone?.trim()
      const results = phoneTest.exec(phone)
      if (results !== null && results.length > 8) {
        return "(" + results[3] + ")" + results[4] + "-" + results[5] + (typeof results[8] !== "undefined" ? " x" + results[8] : "")
      }
      else {
        return phone
      }
    },
  }
}

</script>

<style lang="sass">
@import "../../assets/sass/colors"

.manage-users-container
  text-align: center
  margin: 0 auto 1rem
  padding-top: 2rem
  &.slide-up
    margin: auto
  &.slide-down
    margin: 3rem auto auto

  .new-user-button.button
    position: absolute
    right: 2rem
    text-decoration: none
    top: 2rem

  .grid-container
    margin: 5.5rem auto 4rem
    min-height: 0
    min-width: 0
    text-align: left
    width: 75%

    // Have to use !important here as the default attribute is injected directly to sb-table
    // so without !important, this attribute would be overwritten every time
    // Could be removed once direct style injection on sb-table is removed
    .grid-header, .grid-content
      grid-template-columns: 2fr 2fr 2fr 1fr 1fr !important

    .grid-header
      font-weight: bolder

    .grid-content
      margin-top: 1.75rem
      min-width: 0
      div
        word-wrap: break-word
        word-break: break-all

    .edit-cell, .delete-cell
      text-align: right

    .delete-user
      color: $primary-color
      cursor: pointer
      &:hover
        color: $negative-hover

    .delete
      display: none

  .error-message-bubble
    background: $action-alert
    color: $title-color
    font-size: 1.15rem
    left: 0
    margin: 0
    position: absolute
    right: 0
    text-align: center
    top: 0
    transition: all 0.7s ease
    &.slide-up
      opacity: 0
      padding: 0
    &.slide-down
      opacity: 1
      padding: 1rem
</style>